import w from "./extends.mjs";
import L from "./objectWithoutPropertiesLoose.mjs";
import * as o from "react";
import n from "./index180.mjs";
import * as V from "react-dom";
import { jsxs as j, jsx as E } from "react/jsx-runtime";
import P from "./useForkRef.mjs";
import C from "./ownerWindow.mjs";
import U from "./debounce.mjs";
import Z from "./useEnhancedEffect.mjs";
const q = ["onChange", "maxRows", "minRows", "style", "value"];
function h(i) {
  return parseInt(i, 10) || 0;
}
const G = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function N(i) {
  return i == null || Object.keys(i).length === 0 || i.outerHeightStyle === 0 && !i.overflow;
}
const J = /* @__PURE__ */ o.forwardRef(function(c, W) {
  const {
    onChange: v,
    maxRows: m,
    minRows: d = 1,
    style: b,
    value: p
  } = c, M = L(c, q), {
    current: _
  } = o.useRef(p != null), l = o.useRef(null), k = P(W, l), x = o.useRef(null), u = o.useRef(0), [R, S] = o.useState({
    outerHeightStyle: 0
  }), g = o.useCallback(() => {
    const e = l.current, t = C(e).getComputedStyle(e);
    if (t.width === "0px")
      return {
        outerHeightStyle: 0
      };
    const r = x.current;
    r.style.width = t.width, r.value = e.value || c.placeholder || "x", r.value.slice(-1) === `
` && (r.value += " ");
    const f = t.boxSizing, B = h(t.paddingBottom) + h(t.paddingTop), D = h(t.borderBottomWidth) + h(t.borderTopWidth), O = r.scrollHeight;
    r.value = "x";
    const y = r.scrollHeight;
    let a = O;
    d && (a = Math.max(Number(d) * y, a)), m && (a = Math.min(Number(m) * y, a)), a = Math.max(a, y);
    const F = a + (f === "border-box" ? B + D : 0), I = Math.abs(a - O) <= 1;
    return {
      outerHeightStyle: F,
      overflow: I
    };
  }, [m, d, c.placeholder]), H = (e, s) => {
    const {
      outerHeightStyle: t,
      overflow: r
    } = s;
    return u.current < 20 && (t > 0 && Math.abs((e.outerHeightStyle || 0) - t) > 1 || e.overflow !== r) ? (u.current += 1, {
      overflow: r,
      outerHeightStyle: t
    }) : (process.env.NODE_ENV !== "production" && u.current === 20 && console.error(["MUI: Too many re-renders. The layout is unstable.", "TextareaAutosize limits the number of renders to prevent an infinite loop."].join(`
`)), e);
  }, T = o.useCallback(() => {
    const e = g();
    N(e) || S((s) => H(s, e));
  }, [g]), z = () => {
    const e = g();
    N(e) || V.flushSync(() => {
      S((s) => H(s, e));
    });
  };
  o.useEffect(() => {
    const e = () => {
      u.current = 0, l.current && z();
    }, s = U(() => {
      u.current = 0, l.current && z();
    });
    let t;
    const r = l.current, f = C(r);
    return f.addEventListener("resize", s), typeof ResizeObserver < "u" && (t = new ResizeObserver(e), t.observe(r)), () => {
      s.clear(), f.removeEventListener("resize", s), t && t.disconnect();
    };
  }), Z(() => {
    T();
  }), o.useEffect(() => {
    u.current = 0;
  }, [p]);
  const A = (e) => {
    u.current = 0, _ || T(), v && v(e);
  };
  return /* @__PURE__ */ j(o.Fragment, {
    children: [/* @__PURE__ */ E("textarea", w({
      value: p,
      onChange: A,
      ref: k,
      rows: d,
      style: w({
        height: R.outerHeightStyle,
        // Need a large enough difference to allow scrolling.
        // This prevents infinite rendering loop.
        overflow: R.overflow ? "hidden" : void 0
      }, b)
    }, M)), /* @__PURE__ */ E("textarea", {
      "aria-hidden": !0,
      className: c.className,
      readOnly: !0,
      ref: x,
      tabIndex: -1,
      style: w({}, G.shadow, b, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (J.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  className: n.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: n.oneOfType([n.number, n.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: n.oneOfType([n.number, n.string]),
  /**
   * @ignore
   */
  onChange: n.func,
  /**
   * @ignore
   */
  placeholder: n.string,
  /**
   * @ignore
   */
  style: n.object,
  /**
   * @ignore
   */
  value: n.oneOfType([n.arrayOf(n.string), n.number, n.string])
});
export {
  J as TextareaAutosize
};
//# sourceMappingURL=TextareaAutosize.mjs.map
